/* ── 0. Константи ──────────────────────────────────────────────── */
function getLangPrefix() {
    const path = window.location.pathname;
    if (/^\/(ru)(\/|$)/.test(path)) return '/ru';
    if (/^\/(en)(\/|$)/.test(path)) return '/en';
    const cookie = document.cookie.split(';').map(c => c.trim())
        .find(c => c.startsWith('ul='));
    if (cookie) {
        const val = cookie.split('=')[1];
        if (val === 'ru') return '/ru';
        if (val === 'en') return '/en';
    }
    return '';
}

const { protocol, host, hostname } = location;

const mirohostUrl = `${protocol}//` + (host || hostname).replace('www.', '').replace('imena', 'mirohost').replace('ua', 'net');

const ORDER_BASE_URL = mirohostUrl +  getLangPrefix() + '/cloud/order';

/* Отримуємо рядки з HTML (блок #js-i18n в index.html) */
const _i = document.getElementById('js-i18n')?.dataset ?? {};
const I18N = {
    cardPricePrefix:      _i.cardPricePrefix      ?? 'від',
    cardPriceSuffix:      _i.cardPriceSuffix      ?? 'грн/міс',
    cardBtnLabel:         _i.cardBtnLabel         ?? 'Детальніше',
    cardBtnUnavailable:   _i.cardBtnUnavailable   ?? 'Недоступно',
    mobStep1:           _i.mobStep1           ?? 'Крок 1. Оберіть рішення',
    mobStep2:           _i.mobStep2           ?? 'Крок 2. Оберіть тип ресурсів',
    mobTooltipCloseLabel: _i.mobTooltipCloseLabel ?? 'Закрити',
    mobToastNoDedicated: _i.mobToastNoDedicated ?? 'Dedicated vCPU доступний в бізнес рішеннях Flex, Plus, Power',
    mobTooltipDedicated: _i.mobTooltipDedicated ?? 'Виділені CPU та RAM, зарезервовані лише для вашого сервера. Стабільна та передбачувана продуктивність',
    mobTooltipShared:   _i.mobTooltipShared   ?? 'Віртуальні CPU та RAM спільно використовуються з іншими серверами на хості. Гнучке та економічне рішення для більшості задач',
    mobNoResults:       _i.mobNoResults       ?? 'Нічого не знайдено',
    redirectTitle:      _i.redirectTitle      ?? 'Шановний відвідувач!',
    redirectText:       _i.redirectText       ?? 'Наша компанія надає послуги Cloud Server під торговою маркою MiroHost.<br><br>Ви будете перенаправлені на сайт MiroHost.',
};

/* ── 1. cards-data.js ──────────────────────────────────────────── */
function buildCardsData() {
    const SOLUTION_ORDER = ['GO', 'FLEX', 'PLUS', 'POWER'];

    const servers = (window.allCloudOrders?.servers ?? [])
        .filter(s => s.months === 12).map(s => ({...s, price: s.price / 12 }));

    // Deduplicate by title — keep min price across datacenters
    const byTitle = new Map();
    for (const s of servers) {
        const cur = byTitle.get(s.title);
        if (!cur || s.price < cur.price) byTitle.set(s.title, s);
    }

    // Group: solution → "cpuType-cpuBrand" → [server]
    const TYPE_ORDER  = { shared: 0, dedicated: 1 };
    const BRAND_ORDER = { intel: 0, amd: 1 };

    const tabMap = new Map();
    for (const s of byTitle.values()) {
        const sol = s.solution.toUpperCase();
        const key = s.cpuType.toLowerCase() + '-' + s.cpuManufacturer.toLowerCase();
        if (!tabMap.has(sol)) tabMap.set(sol, new Map());
        const secMap = tabMap.get(sol);
        if (!secMap.has(key)) secMap.set(key, []);
        secMap.get(key).push(s);
    }

    const tabs = SOLUTION_ORDER
        .filter(sol => tabMap.has(sol))
        .map(sol => {
            const secMap   = tabMap.get(sol);
            const sections = [...secMap.values()]
                .map(raw => {
                    const cards = raw.sort((a, b) => a.price - b.price);
                    const first = cards[0];
                    return {
                        cpuType:  first.cpuType.toLowerCase(),
                        cpuBrand: first.cpuManufacturer.toLowerCase(),
                        cards: cards.map(s => ({
                            id:    s.title,
                            title: 'Cloud ' + s.title,
                            price: s.price,
                            specs: { vCPU: s.cpuCount, RAM: s.ram, SSD: s.disk },
                            hold:  !!s.hold,
                        }))
                    };
                })
                .sort((a, b) =>
                    (TYPE_ORDER[a.cpuType]   - TYPE_ORDER[b.cpuType]) ||
                    (BRAND_ORDER[a.cpuBrand] - BRAND_ORDER[b.cpuBrand])
                );

            return { id: sol.toLowerCase(), sections };
        });

    return { tabs };
}

const cardsData = buildCardsData();

(function fillPricingCards() {
    const fmt = n => Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0');
    document.addEventListener('DOMContentLoaded', () => {
        cardsData.tabs.forEach(tab => {
            const minPrice = tab.sections[0]?.cards[0]?.price;
            if (minPrice == null) return;
            const link = document.querySelector(`a.pricing-card[href="#${tab.id}"]`);
            if (!link) return;
            const span = link.querySelector('.price-button span');
            if (span) span.textContent = fmt(minPrice);
        });
    });
})();

/* ── 2. collapsed.js (Collapsible) ─────────────────────────────── */
class Collapsible {
    static init() {
        const collapsibleToggles = document.querySelectorAll('[data-collapsible-toggle]');

        collapsibleToggles.forEach(toggle => {
            if (toggle.dataset.collapsibleBound) return;
            toggle.dataset.collapsibleBound = 'true';

            toggle.addEventListener('click', this.handleToggleClick.bind(this));

            if (toggle.hasAttribute('data-close-outside')) {
                this.initClickOutside(toggle);
            }
        });
    }

    static handleToggleClick(event) {
        event.stopPropagation();

        const toggle = event.currentTarget;
        const content = toggle.nextElementSibling;

        if (content && content.classList.contains('collapsible-content')) {
            this.toggle(toggle, content);
        }
    }

    static initClickOutside(toggle) {
        const content = toggle.nextElementSibling;

        if (!content || !content.classList.contains('collapsible-content')) {
            return;
        }

        const clickOutsideHandler = event => {
            if (toggle.classList.contains('collapsed')) {
                return;
            }

            const isClickInside = toggle.contains(event.target) || content.contains(event.target);

            if (!isClickInside) {
                Collapsible.close(toggle);
            }
        };

        document.addEventListener('click', clickOutsideHandler);

        toggle._clickOutsideHandler = clickOutsideHandler;
    }

    static toggle(toggle, content) {
        toggle.classList.toggle('collapsed');
        content.classList.toggle('collapsed');
    }

    static open(toggle) {
        const content = toggle.nextElementSibling;
        if (content && content.classList.contains('collapsible-content')) {
            toggle.classList.remove('collapsed');
            content.classList.remove('collapsed');
        }
    }

    static close(toggle) {
        const content = toggle.nextElementSibling;
        if (content && content.classList.contains('collapsible-content')) {
            toggle.classList.add('collapsed');
            content.classList.add('collapsed');
        }
    }

    static closeAll() {
        const collapsibleToggles = document.querySelectorAll('[data-collapsible-toggle]');
        collapsibleToggles.forEach(toggle => this.close(toggle));
    }

    static openAll() {
        const collapsibleToggles = document.querySelectorAll('[data-collapsible-toggle]');
        collapsibleToggles.forEach(toggle => this.open(toggle));
    }
}

/* ── 3. slider.js (StackSlider) ────────────────────────────────── */
class StackSlider {
    constructor(sliderContainer) {
        this.sliderContainer = sliderContainer;
        this.slider = sliderContainer.querySelector('.swiper');
        this.slides = Array.from(this.slider.querySelectorAll('.slide'));
        this.currentIndex = 0;
        this.isAnimating = false;
        this.maxVisibleSlides = Math.min(3, this.slides.length);
        this.touchStartX = 0;
        this.touchEndX = 0;
        this.minSwipeDistance = 50;

        this.init();
    }

    init() {
        this.updateStackPosition();
        this.createPagination();
        this.attachEvents();
        this.attachSwipeEvents();
    }

    createPagination() {
        const pagination = this.sliderContainer.querySelector('.pagination');
        if (!pagination) return;

        pagination.innerHTML = '';

        this.slides.forEach((_, index) => {
            const dot = document.createElement('div');
            dot.className = 'pagination-dot';
            if (index === this.currentIndex) dot.classList.add('active');
            dot.addEventListener('click', () => this.goToSlide(index));
            pagination.appendChild(dot);
        });
    }

    updatePagination() {
        const dots = this.sliderContainer.querySelectorAll('.pagination-dot');
        dots.forEach((dot, index) => {
            dot.classList.toggle('active', index === this.currentIndex);
        });
    }

    attachEvents() {
        const nextBtn = this.sliderContainer.querySelector('.next-btn');
        const prevBtn = this.sliderContainer.querySelector('.prev-btn');

        if (nextBtn) {
            nextBtn.addEventListener('click', () => this.next());
        }
        if (prevBtn) {
            prevBtn.addEventListener('click', () => this.prev());
        }
    }

    attachSwipeEvents() {
        this.slider.addEventListener('touchstart', (e) => {
            if (this.isAnimating) return;
            this.touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        this.slider.addEventListener('touchend', (e) => {
            if (this.isAnimating) return;
            this.touchEndX = e.changedTouches[0].screenX;
            this.handleSwipe();
        }, { passive: true });
    }

    handleSwipe() {
        if (this.slides.length <= 1) return;

        const swipeDistance = this.touchEndX - this.touchStartX;

        if (Math.abs(swipeDistance) >= this.minSwipeDistance) {
            if (swipeDistance > 0) {
                this.prev();
            } else {
                this.next();
            }
        }
    }

    getVisibleIndices() {
        const indices = [];
        for (let i = 0; i < this.maxVisibleSlides; i++) {
            indices.push((this.currentIndex + i) % this.slides.length);
        }
        return indices;
    }

    updateStackPosition() {
        const visibleIndices = this.getVisibleIndices();

        this.slides.forEach((slide, index) => {
            const position = visibleIndices.indexOf(index);
            slide.style.transition = 'none';

            if (position === 0) {
                slide.style.transform = 'translate3d(0, 0, 0px) rotateY(0deg)';
                slide.style.opacity = '1';
            } else if (position === 1) {
                slide.style.transform = 'translate3d(10px, -10px, -30px) rotateY(2deg)';
                slide.style.opacity = '1';
            } else if (position === 2) {
                slide.style.transform = 'translate3d(20px, -20px, -60px) rotateY(4deg)';
                slide.style.opacity = '1';
            } else {
                slide.style.transform = 'translate3d(20px, -20px, -60px) rotateY(4deg)';
                slide.style.opacity = '0';
            }
        });
    }

    next() {
        if (this.isAnimating || this.slides.length <= 1) return;

        const previousIndex = this.currentIndex;
        this.currentIndex = (this.currentIndex + 1) % this.slides.length;
        this.animateForward(previousIndex);
        this.updatePagination();
    }

    prev() {
        if (this.isAnimating || this.slides.length <= 1) return;

        const previousIndex = this.currentIndex;
        this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
        this.animateBackward(previousIndex);
        this.updatePagination();
    }

    goToSlide(index) {
        if (this.isAnimating || index === this.currentIndex || this.slides.length <= 1) return;

        const diff = index - this.currentIndex;
        const steps = diff > 0 ? diff : this.slides.length + diff;

        this.animateToSlide(index, steps);
    }

    animateToSlide(targetIndex, stepsRemaining) {
        if (stepsRemaining === 0 || this.currentIndex === targetIndex) {
            return;
        }

        const forward = (targetIndex - this.currentIndex + this.slides.length) % this.slides.length;
        const backward = (this.currentIndex - targetIndex + this.slides.length) % this.slides.length;

        if (forward <= backward) {
            this.next();
        } else {
            this.prev();
        }

        setTimeout(() => {
            this.animateToSlide(targetIndex, stepsRemaining - 1);
        }, 1000);
    }

    animateForward(previousIndex) {
        this.isAnimating = true;

        const oldVisibleIndices = [];
        const newVisibleIndices = [];

        for (let i = 0; i < this.maxVisibleSlides; i++) {
            oldVisibleIndices.push((previousIndex + i) % this.slides.length);
            newVisibleIndices.push((this.currentIndex + i) % this.slides.length);
        }

        const prevIdx = previousIndex;
        const newIdx = (previousIndex + 1) % this.slides.length;
        const secondIdx = this.slides.length >= 3 ? (previousIndex + 2) % this.slides.length : null;

        const prevSlide = this.slides[prevIdx];
        const newSlide = this.slides[newIdx];
        const secondSlide = this.slides.length >= 3 ? this.slides[secondIdx] : null;

        setTimeout(() => {
            this.slides.forEach((slide, idx) => {
                const isInOldStack = oldVisibleIndices.includes(idx);
                const isInNewStack = newVisibleIndices.includes(idx);

                if (isInOldStack && !isInNewStack) {
                    slide.style.transition = 'none';
                    slide.style.opacity = '0';
                }
                if (isInNewStack) {
                    slide.style.opacity = '1';
                }
            });
        }, 1000);

        prevSlide.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.5s';
        prevSlide.style.transform = 'translate3d(-65%, 0, 40px) rotateY(-90deg)';

        setTimeout(() => {
            prevSlide.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.5s';
            prevSlide.style.transform = 'translate3d(-65%, 0, -100px) rotateY(-90deg)';
            setTimeout(() => {
                prevSlide.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.5s';
                if (secondSlide) {
                    prevSlide.style.transform = 'translate3d(20px, -27px, -150px) rotateY(-180deg)';
                } else {
                    prevSlide.style.transform = 'translate3d(10px, -17px, -150px) rotateY(-180deg)';
                }

                newSlide.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
                newSlide.style.transform = 'translate3d(0, 0, 0px) rotateY(0deg)';

                if (secondSlide) {
                    secondSlide.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
                    secondSlide.style.transform = 'translate3d(10px, -10px, -30px) rotateY(0deg)';
                }

                setTimeout(() => {
                    prevSlide.style.transition = 'transform 0s';
                    if (secondSlide) {
                        prevSlide.style.transform = 'translate3d(20px, -20px, -60px) rotateY(0deg)';
                    } else {
                        prevSlide.style.transform = 'translate3d(10px, -10px, -30px) rotateY(0deg)';
                    }

                    this.isAnimating = false;
                }, 300);
            }, 300);
        }, 300);
    }

    animateBackward(previousIndex) {
        this.isAnimating = true;

        const newIdx = this.currentIndex;
        const firstIdx = previousIndex;
        const secondIdx = (previousIndex + 1) % this.slides.length;

        const newSlide = this.slides[newIdx];
        const firstSlide = this.slides[firstIdx];
        const secondSlide = this.slides.length >= 3 ? this.slides[secondIdx] : null;

        this.slides.forEach((slide, idx) => {
            if (idx !== newIdx && idx !== firstIdx && idx !== secondIdx) {
                slide.style.transform = 'translate3d(20px, -20px, -60px) rotateY(4deg)';
                slide.style.opacity = '0';
            }
        });

        newSlide.style.transition = 'transform 0s';
        newSlide.style.transform = 'translate3d(20px, -20px, -150px) rotateY(-180deg)';
        newSlide.style.opacity = '1';

        setTimeout(() => {
            firstSlide.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
            firstSlide.style.transform = 'translate3d(10px, -10px, -30px) rotateY(0deg)';

            if (secondSlide) {
                secondSlide.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
                secondSlide.style.transform = 'translate3d(20px, -20px, -60px) rotateY(0deg)';
            }

            newSlide.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
            newSlide.style.transform = 'translate3d(-65%, 0, -150px) rotateY(-90deg)';

            setTimeout(() => {
                newSlide.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
                newSlide.style.transform = 'translate3d(-65%, 0, 40px) rotateY(-90deg)';
                setTimeout(() => {
                    newSlide.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
                    newSlide.style.transform = 'translate3d(0, 0, 0px) rotateY(0deg)';

                    this.isAnimating = false;
                }, 400);
            }, 200);
        }, 50);
    }
}

/* ── 4. cards-renderer.js ──────────────────────────────────────── */
(function renderCards() {
    const SPEC_ICONS = {
        vCPU: { src: '../i/cpu-icon.svg', alt: 'CPU' },
        RAM:  { src: '../i/ram-icon.svg', alt: 'RAM' },
        SSD:  { src: '../i/ssd-icon.svg', alt: 'SSD' },
    };

    const CPU_BRAND_LABEL = { intel: 'Intel®', amd: 'AMD' };

    function buildHeader(cpuType, cpuBrand) {
        const type = cpuType === 'dedicated' ? 'Dedicated' : 'Shared';
        return `${type} vCPU ${CPU_BRAND_LABEL[cpuBrand]}`;
    }

    function formatPrice(price) {
        return price.toLocaleString('uk-UA');
    }

    function formatSpec(label, value) {
        return label === 'vCPU' ? value : `${value} GB`;
    }

    function renderCard(card, cpuType, cpuBrand) {
        const specsHtml = Object.entries(card.specs).map(([label, value]) => {
            const icon = SPEC_ICONS[label];
            return `<div class="spec-item">
                        <div class="spec-icon">
                            <img src="${icon.src}" alt="${icon.alt}" width="36" height="36">
                        </div>
                        <div class="spec-label">${label}</div>
                        <div class="spec-value">${formatSpec(label, value)}</div>
                    </div>`;
        }).join('');

        const cardInner = `
                        <div class="card-header">${buildHeader(cpuType, cpuBrand)}</div>
                        <div class="card-content">
                            <div class="card-specs">${specsHtml}</div>
                            <div class="card-title">${card.title}</div>
                            <div class="card-price">${I18N.cardPricePrefix} ${formatPrice(card.price)} ${I18N.cardPriceSuffix}</div>
                            <div class="outline-block ${card.hold ? 'button-light' : 'config-button'}">${card.hold ? I18N.cardBtnUnavailable : I18N.cardBtnLabel}</div>
                        </div>`;

        const wrapper = card.hold
            ? `<div class="outline-block ovh d-block">${cardInner}</div>`
            : `<a href="${ORDER_BASE_URL}/${card.id}?step=settings-order" class="outline-block ovh d-block">${cardInner}</a>`;

        return `<div class="server-card">${wrapper}</div>`;
    }

    function renderStandalone(section) {
        const div = document.createElement('div');
        div.className = 'tab__block_short';
        div.innerHTML = `<div class="${section.cpuBrand}_icon"></div>${renderCard(section.cards[0], section.cpuType, section.cpuBrand)}`;
        return div;
    }

    function renderSlider(section) {
        const slidesHtml = section.cards.map((card, i) =>
            `<div class="slide${i === 0 ? ' active' : ''}">
                <div class="slide-content">${renderCard(card, section.cpuType, section.cpuBrand)}</div>
            </div>`
        ).join('');

        const div = document.createElement('div');
        div.className = 'tab__block';
        div.innerHTML = `
            <div class="${section.cpuBrand}_icon"></div>
            <div class="swiper__container">
                <div class="swiper">${slidesHtml}</div>
                <div class="navigation">
                    <button class="nav-btn prev-btn">
                        <img src="../i/angel-left-thin.svg" alt="Previous">
                    </button>
                    <div class="pagination"></div>
                    <button class="nav-btn next-btn">
                        <img src="../i/angel-right-thin.svg" alt="Next">
                    </button>
                </div>
            </div>`;
        return div;
    }

    cardsData.tabs.forEach(tab => {
        const panel = document.getElementById(tab.id);
        if (!panel) return;

        const container = panel.querySelector('.tab__content__container');
        if (!container) return;

        container.classList.add('center-justify');

        tab.sections.forEach(section => {
            container.appendChild(
                section.cards.length === 1
                    ? renderStandalone(section)
                    : renderSlider(section)
            );
        });
    });
})();

/* ── 5. tabs.js ────────────────────────────────────────────────── */
(function initTabs() {
    class Tabs {
        constructor() {
            this.tabButtons = document.querySelectorAll('.tab-button');
            this.tabPanels = document.querySelectorAll('.tab-panel');

            this.init();
        }

        init() {
            this.tabButtons.forEach(button => {
                button.addEventListener('click', e => {
                    const tabName = e.currentTarget.dataset.tab;

                    const href = `#${tabName}`;
                    if (window.location.hash !== href) {
                        window.history.pushState(null, null, href);
                    }
                    this.switchTab(tabName);
                });
            });

            this.handleHashOnLoad();

            window.addEventListener('hashchange', () => {
                this.handleHashChange();
            });

            this.setupSmoothScroll();
        }

        switchTab(tabName) {
            this.tabButtons.forEach(button => {
                button.classList.remove('active');
            });

            this.tabPanels.forEach(panel => {
                panel.classList.remove('active');
            });

            const activeButton = document.querySelector(`[data-tab="${tabName}"]`);
            if (activeButton) {
                activeButton.classList.add('active');
            }

            const activePanel = document.getElementById(tabName);
            if (activePanel) {
                activePanel.classList.add('active');
            }
        }

        handleHashOnLoad() {
            const hash = window.location.hash.substring(1);
            if (hash) {
                this.switchTab(hash);
                this.scrollToTabs();
            }
        }

        handleHashChange() {
            const hash = window.location.hash.substring(1);
            if (hash) {
                this.switchTab(hash);
                this.scrollToTabs();
            }
        }

        scrollToTabs() {
            const tabsSection = document.querySelector('.tabs-section');
            if (tabsSection) {
                setTimeout(() => {
                    tabsSection.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                    });
                }, 100);
            }
        }

        setupSmoothScroll() {
            document.querySelectorAll('a[href^="#"]').forEach(anchor => {
                anchor.addEventListener('click', e => {
                    const href = anchor.getAttribute('href');
                    const tabName = href.substring(1);

                    const tabExists = document.getElementById(tabName);
                    if (tabExists) {
                        e.preventDefault();

                        const currentHash = window.location.hash;
                        if (currentHash === href) {
                            this.switchTab(tabName);
                            this.scrollToTabs();
                        } else {
                            window.location.hash = href;
                        }
                    }
                });
            });
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        new Tabs();
    });
})();

/* ── 6. slider-init (з slider.js) ──────────────────────────────── */
document.querySelectorAll('.swiper__container').forEach(sliderContainer => {
    new StackSlider(sliderContainer);
});

/* ── 7. mobile-cards.js ────────────────────────────────────────── */
(function initMobileCards() {
    const VALID_TABS = new Set(['go', 'flex', 'plus', 'power']);

    class MobileCards {
        constructor() {
            this.BREAKPOINT = 768;
            this.activeVcpu = 'shared';
            this.activeTab  = 'flex';

            this.cards = [];
            this.tabTitles = {};
            this.sliderInstance = null;
            this.mobileSection  = null;
            this.desktopSection = null;
            this._toastTimer = null;

            this.init();
        }

        init() {
            document.addEventListener('DOMContentLoaded', () => {
                this.desktopSection = document.querySelector('.tabs-section');
                if (!this.desktopSection) return;

                this.collectCards();
                this.collectTabTitles();
                this.buildMobileSection();
                this.applyMode();

                window.addEventListener('hashchange', () => this.handleHash());
                let _lastWidth = window.innerWidth;
                window.addEventListener('resize', () => {
                    const newWidth = window.innerWidth;
                    if (newWidth === _lastWidth) return;
                    _lastWidth = newWidth;
                    this.applyMode();
                });

                document.querySelectorAll('a.pricing-card[href^="#"]').forEach(link => {
                    link.addEventListener('click', e => {
                        const tabName = link.getAttribute('href').substring(1);
                        if (!VALID_TABS.has(tabName)) return;

                        if (this.isMobile()) {
                            e.preventDefault();
                            this.activateTab(tabName, { scroll: true, updateHash: true });
                        }
                    });
                });
            });
        }

        isMobile() {
            return window.innerWidth <= this.BREAKPOINT;
        }

        handleHash(scroll = false) {
            if (!this.isMobile()) return;
            const hash = window.location.hash.substring(1);
            if (VALID_TABS.has(hash)) {
                this.activateTab(hash, { scroll, updateHash: false });
            }
        }

        activateTab(tabName, { scroll = false, updateHash = true } = {}) {
            if (tabName === 'go' && this.activeVcpu === 'dedicated') {
                this.activeVcpu = 'shared';
            }

            this.activeTab = tabName;

            if (updateHash) {
                const href = `#${tabName}`;
                if (window.location.hash !== href) {
                    window.history.pushState(null, null, href);
                }
            }

            this.render();

            if (scroll) {
                this.scrollToSwiper();
            }
        }

        scrollToSwiper() {
            setTimeout(() => {
                this.mobileSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 50);
        }

        showToast(message) {
            let toast = this.mobileSection.querySelector('.mob-dedicated-toast');
            if (!toast) {
                toast = document.createElement('div');
                toast.className = 'mob-dedicated-toast';
                this.mobileSection.appendChild(toast);
            }
            toast.textContent = message;
            toast.classList.add('mob-dedicated-toast--visible');

            clearTimeout(this._toastTimer);
            this._toastTimer = setTimeout(() => {
                toast.classList.remove('mob-dedicated-toast--visible');
            }, 3000);
        }

        collectTabTitles() {
            ['go', 'flex', 'plus', 'power'].forEach(tabName => {
                const panel = document.getElementById(tabName);
                if (!panel) return;
                const h2 = panel.querySelector('h2');
                const p  = panel.querySelector('p');
                this.tabTitles[tabName] = {
                    h2: h2 ? h2.textContent.trim().replace(/\s+/g, ' ') : '',
                    p:  p  ? p.textContent.trim().replace(/\s+/g, ' ')  : '',
                };
            });
        }

        collectCards() {
            const TAB_NAMES = ['go', 'flex', 'plus', 'power'];

            TAB_NAMES.forEach(tabName => {
                const panel = document.getElementById(tabName);
                if (!panel) return;

                panel.querySelectorAll('.tab__block_short .server-card').forEach(cardEl => {
                    this.cards.push(this.extractCard(cardEl, tabName));
                });

                panel.querySelectorAll('.slide .server-card').forEach(cardEl => {
                    this.cards.push(this.extractCard(cardEl, tabName));
                });
            });
        }

        extractCard(cardEl, tabName) {
            const headerText = (cardEl.querySelector('.card-header')?.textContent || '').trim();
            const priceText  = (cardEl.querySelector('.card-price')?.textContent  || '').trim();
            const headerLow  = headerText.toLowerCase();

            let cpuBrand = 'intel';
            if (headerLow.includes('amd')) cpuBrand = 'amd';

            return {
                tabName,
                vcpuType: headerLow.includes('dedicated') ? 'dedicated' : 'shared',
                cpuBrand,
                priceNum:  this.parsePrice(priceText),
                el: cardEl,
            };
        }

        parsePrice(text) {
            const digits = text.replace(/\s/g, '').match(/\d+/g);
            if (!digits) return Infinity;
            return parseInt(digits.join(''), 10);
        }

        buildMobileSection() {
            const sec = document.createElement('div');
            sec.id = 'mobile-cards-section';
            sec.className = 'mobile-cards-section';
            sec.style.display = 'none';

            sec.innerHTML = `
                <div class="mob-steps-container">
                    <div style="text-align: center">
                        ${I18N.mobStep1}
                    </div>
                    <div class="mob-bottom-tabs">
                        <div class="mob-tab-btn outline-block" data-tab="go">
                            <img class="mob-tab-icon" src="../i/iconmonstr-layout-vertical-filled.svg" alt="GO">
                            <span>GO</span>
                        </div>
                        <div class="mob-tab-btn outline-block" data-tab="flex">
                            <img class="mob-tab-icon" src="../i/iconmonstr-layout-filled.svg" alt="FLEX">
                            <span>FLEX</span>
                        </div>
                        <div class="mob-tab-btn outline-block" data-tab="plus">
                            <img class="mob-tab-icon" src="../i/iconmonstr-dashboard-filled.svg" alt="PLUS">
                            <span>PLUS</span>
                        </div>
                        <div class="mob-tab-btn outline-block" data-tab="power">
                            <img class="mob-tab-icon" src="../i/iconmonstr-layout-table-filled.svg" alt="POWER">
                            <span>POWER</span>
                        </div>
                    </div>

                    <div style="text-align: center; font-size: 14px;" class="mob-cpu-label">
                        ${I18N.mobStep2}
                        <span style="position: relative; margin-left: -8px; top: 5px;">
                            <span class="info-icon" id="mob-cpu-tooltip-trigger" style="margin-left: 0px;">
                                <span class="tooltip mob-cpu-tooltip" id="mob-cpu-tooltip" style="width: 280px; z-index: 200;">
                                    <button type="button" class="tooltip-close" id="mob-cpu-tooltip-close" aria-label="${I18N.mobTooltipCloseLabel}"></button>
                                    <span id="mob-cpu-tooltip-text" class="mob-cpu-tooltip-text"></span>
                                </span>
                            </span>
                        </span>
                    </div>
                    <div class="mob-filter-bar">
                        <div class="mob-filter-btn outline-block" data-vcpu="shared">
                                SHARED vCPU
                        </div>
                        <div class="mob-filter-btn outline-block" data-vcpu="dedicated">
                                DEDICATED vCPU
                        </div>
                    </div>
                </div>

                <div class="mob-flex-header" id="mob-flex-header" style="display:none;">
                    <h2 class="mob-flex-title" id="mob-tab-title"></h2>
                    <p class="mob-flex-subtitle" id="mob-tab-subtitle"></p>
                </div>

                <div class="mob-cpu-icons" id="mob-cpu-icons" style="display:none;"></div>

                <div class="mob-swiper-wrapper" id="mob-swiper-wrapper"></div>
            `;

            this.desktopSection.insertAdjacentElement('afterend', sec);
            this.mobileSection = sec;

            sec.querySelectorAll('.mob-filter-btn').forEach(btn => {
                btn.addEventListener('click', () => {
                    const val = btn.dataset.vcpu;

                    if (val === 'dedicated' && this.activeTab === 'go') {
                        this.showToast(I18N.mobToastNoDedicated);
                        return;
                    }

                    if (this.activeVcpu !== val) {
                        this.activeVcpu = val;
                        this.render();
                    }
                });
            });

            sec.querySelectorAll('.mob-tab-btn').forEach(btn => {
                btn.addEventListener('click', () => {
                    const val = btn.dataset.tab;
                    const isAlreadyActive = (this.activeTab === val);

                    if (val === 'go' && !isAlreadyActive && this.activeVcpu === 'dedicated') {
                        this.activeVcpu = 'shared';
                    }

                    this.activeTab = isAlreadyActive ? null : val;

                    const newHash = this.activeTab ? `#${this.activeTab}` : ' ';
                    if (window.location.hash !== newHash) {
                        window.history.pushState(null, null, this.activeTab ? `#${this.activeTab}` : location.pathname);
                    }

                    this.render();
                    this.scrollToSwiper();
                });
            });

            const tooltipTrigger = sec.querySelector('#mob-cpu-tooltip-trigger');
            const tooltip = sec.querySelector('#mob-cpu-tooltip');
            const tooltipClose = sec.querySelector('#mob-cpu-tooltip-close');

            if (tooltipTrigger && tooltip && tooltipClose) {
                tooltipTrigger.addEventListener('click', (e) => {
                    e.stopPropagation();

                    const isCurrentlyActive = tooltip.classList.contains('active');

                    document.querySelectorAll('.tooltip.active').forEach(t => t.classList.remove('active'));

                    if (!isCurrentlyActive) {
                        tooltip.classList.add('active');

                        const triggerRect = tooltipTrigger.getBoundingClientRect();
                        const tooltipRect = tooltip.getBoundingClientRect();

                        tooltip.classList.remove('tooltip-down');

                        if (triggerRect.top - tooltipRect.height - 15 < 0) {
                            tooltip.classList.add('tooltip-down');
                        }
                    }
                });

                tooltipClose.addEventListener('click', (e) => {
                    e.stopPropagation();
                    tooltip.classList.remove('active');
                });

                document.addEventListener('click', (e) => {
                    if (!tooltipTrigger.contains(e.target) && !tooltip.contains(e.target)) {
                        tooltip.classList.remove('active');
                    }
                });

                tooltip.addEventListener('click', (e) => {
                    e.stopPropagation();
                });
            }
        }

        render() {
            if (!this.mobileSection) return;

            this.mobileSection.querySelectorAll('.mob-filter-btn').forEach(btn => {
                btn.classList.toggle('active', btn.dataset.vcpu === this.activeVcpu);

                if (btn.dataset.vcpu === 'dedicated') {
                    const isGoTab = this.activeTab === 'go';
                    btn.classList.toggle('mob-filter-btn--disabled', isGoTab);
                }
            });

            const tooltipText = this.mobileSection.querySelector('#mob-cpu-tooltip-text');
            if (tooltipText) {
                if (this.activeVcpu === 'dedicated') {
                    tooltipText.innerHTML = I18N.mobTooltipDedicated;
                } else {
                    tooltipText.innerHTML = I18N.mobTooltipShared;
                }
            }

            this.mobileSection.querySelectorAll('.mob-tab-btn').forEach(btn =>
                btn.classList.toggle('active', btn.dataset.tab === this.activeTab));

            const tabHeader = this.mobileSection.querySelector('#mob-flex-header');
            if (tabHeader) {
                const title = this.tabTitles[this.activeTab];
                if (this.activeTab && title && title.h2) {
                    tabHeader.style.display = 'block';
                    const h2el = tabHeader.querySelector('#mob-tab-title');
                    const pel  = tabHeader.querySelector('#mob-tab-subtitle');
                    if (h2el) h2el.textContent = title.h2;
                    if (pel)  pel.textContent  = title.p;
                } else {
                    tabHeader.style.display = 'none';
                }
            }

            const filtered = this.cards
                .filter(c => {
                    if (this.activeVcpu && c.vcpuType !== this.activeVcpu) return false;
                    if (this.activeTab  && c.tabName  !== this.activeTab)  return false;
                    return true;
                })
                .sort((a, b) => a.priceNum - b.priceNum);

            this.sliderInstance = null;

            const wrapper = this.mobileSection.querySelector('#mob-swiper-wrapper');
            wrapper.innerHTML = '';

            wrapper.classList.toggle('mob-swiper-wrapper--single', filtered.length === 1);

            this._currentFilteredCards = filtered;
            this._renderCpuIcons(filtered, 0);

            if (filtered.length === 0) {
                wrapper.innerHTML = `<p class="mob-no-results">${I18N.mobNoResults}</p>`;
                return;
            }

            const container = document.createElement('div');
            container.className = 'swiper__container mob-swiper-container';

            const swiperFlex = document.createElement('div');
            swiperFlex.className = 'mob-swiper-flex';
            container.appendChild(swiperFlex);

            const swiperEl = document.createElement('div');
            swiperEl.className = 'swiper';
            swiperFlex.appendChild(swiperEl);

            filtered.forEach((card, i) => {
                const slide = document.createElement('div');
                slide.className = 'slide' + (i === 0 ? ' active' : '');

                const slideContent = document.createElement('div');
                slideContent.className = 'slide-content';

                slideContent.appendChild(card.el.cloneNode(true));

                slide.appendChild(slideContent);
                swiperEl.appendChild(slide);
            });

            const nav = document.createElement('div');
            nav.className = 'navigation';
            nav.innerHTML = `
                <button class="nav-btn prev-btn">
                    <img src="../i/angel-left-thin.svg" alt="Previous">
                </button>
                <div class="pagination"></div>
                <button class="nav-btn next-btn">
                    <img src="../i/angel-right-thin.svg" alt="Next">
                </button>
            `;

            if (filtered.length === 1) {
                nav.style.display = 'none';
            }

            container.appendChild(nav);
            wrapper.appendChild(container);

            this.sliderInstance = new StackSlider(container);

            this._bindSliderChange(container, filtered);
        }

        _renderCpuIcons(filtered, activeIndex) {
            const iconsBlock = this.mobileSection.querySelector('#mob-cpu-icons');
            if (!iconsBlock) return;

            if (filtered.length === 0) {
                iconsBlock.style.display = 'none';
                return;
            }

            iconsBlock.style.display = 'flex';

            const card = filtered[activeIndex] || filtered[0];
            const brand = card ? card.cpuBrand : 'intel';

            if (brand === 'amd') {
                iconsBlock.innerHTML = '<div class="amd_icon mob-cpu-icon-el"></div>';
            } else {
                iconsBlock.innerHTML = '<div class="intel_icon mob-cpu-icon-el"></div>';
            }
        }

        _bindSliderChange(container, filtered) {
            const pagination = container.querySelector('.pagination');
            if (!pagination) return;

            const updateIcon = () => {
                const dots = pagination.querySelectorAll('.pagination-dot');
                let activeIdx = 0;
                dots.forEach((d, i) => { if (d.classList.contains('active')) activeIdx = i; });
                this._renderCpuIcons(filtered, activeIdx);
            };

            const observer = new MutationObserver(updateIcon);
            pagination.querySelectorAll('.pagination-dot').forEach(dot => {
                observer.observe(dot, { attributes: true, attributeFilter: ['class'] });
            });
        }

        applyMode() {
            const isMobile = this.isMobile();

            if (isMobile) {
                this.desktopSection.style.display = 'none';
                this.mobileSection.style.display  = 'block';
                if (this.cards.length === 0) this.collectCards();

                this.handleHash(false);
                this.render();
            } else {
                this.desktopSection.style.display = '';
                this.mobileSection.style.display  = 'none';
            }
        }
    }

    new MobileCards();
})();

/* ── 9. CartBtn.js ─────────────────────────────────────────────── */
(function initCartBtn() {
    const pathMatch = window.location.pathname.match(/\/(new\d+)/);
    const version = pathMatch ? pathMatch[1] : 'new44';
    const storageKey = `mirohost_order_data_${version}`;

    function hasOrderData() {
        try {
            const raw = localStorage.getItem(storageKey);
            if (!raw) return false;
            const data = JSON.parse(raw);
            return !!(data && data.tariff && data.tariff.name);
        } catch {
            return false;
        }
    }

    function updateCartUI() {
        const hasData = hasOrderData();

        const ids = [
            'cart-count-badge',
            'cart-count-badge-mob',
        ];

        ids.forEach(id => {
            const el = document.getElementById(id);
            if (!el) return;
            el.textContent = hasData ? '1' : '0';
            el.classList.toggle('cart-badge--active', hasData);
        });

        const cartBtnIds = ['nav-cart-btn', 'nav-cart-btn-mob'];
        cartBtnIds.forEach(id => {
            const btn = document.getElementById(id);
            if (btn && !btn.dataset.initialized) {
                btn.dataset.initialized = 'true';
                btn.addEventListener('click', () => {
                    if (hasOrderData()) {
                        window.location.href = `/${version}/settings-order`;
                    }
                });
            }
            if (btn) {
                btn.style.cursor = hasOrderData() ? 'pointer' : 'default';
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', updateCartUI);
    } else {
        updateCartUI();
    }

    window.addEventListener('storage', (e) => {
        if (e.key === storageKey) updateCartUI();
    });
})();

/* ── 10. cloud-page.js ─────────────────────────────────────────── */
(function initCloudPage() {
    const MOBILE_BP = 768;

    // [AI-generated] Model: grok-4.7 | DateTime: 2026-11-03 13:46 | Task: #DEVELOPMENT-2430 | Опис змін: заголовок collapsible через textContent, без innerHTML
    function buildCollapsibleShell(titleText) {
        const header = document.createElement('div');
        header.className = 'collapsible-header';
        header.setAttribute('data-collapsible-toggle', '');
        header.style.justifyContent = 'space-between';

        const subtitle = document.createElement('div');
        subtitle.className = 'summary-subtitle';
        const titleSpan = document.createElement('span');
        titleSpan.textContent = titleText;
        subtitle.appendChild(titleSpan);

        const iconWrap = document.createElement('span');
        iconWrap.className = 'collapsible-icon pulse';
        const icon = document.createElement('img');
        icon.src = '../i/plus.svg';
        icon.alt = 'toggle';
        icon.width = 20;
        icon.height = 20;
        iconWrap.appendChild(icon);

        header.appendChild(subtitle);
        header.appendChild(iconWrap);

        const contentWrap = document.createElement('div');
        contentWrap.className = 'collapsible-content collapsed';

        return { header, contentWrap };
    }

    function initDynamicCollapsible(selector, headTag) {
        const containers = document.querySelectorAll(selector);
        if (containers.length === 0) return;

        function syncDom() {
            const isMobile = window.innerWidth <= MOBILE_BP;

            containers.forEach(container => {
                const hasCollapsible = container.querySelector('.collapsible-header') !== null;

                if (isMobile && !hasCollapsible) {
                    const headerNode = container.querySelector(headTag);
                    const pTags = Array.from(container.querySelectorAll('p'));
                    if (!headerNode) return;

                    const originalText = headerNode.textContent.trim();

                    container.dataset.headerText = originalText;

                    const { header, contentWrap } = buildCollapsibleShell(originalText);
                    container.replaceChildren(header, contentWrap);
                    pTags.forEach(p => contentWrap.appendChild(p));
                } else if (!isMobile && hasCollapsible) {
                    const titleText = container.dataset.headerText || '';
                    const pTags = Array.from(container.querySelectorAll('.collapsible-content p'));

                    const heading = document.createElement(headTag);
                    heading.textContent = titleText;
                    container.replaceChildren(heading);
                    pTags.forEach(p => container.appendChild(p));
                }
            });

            if (isMobile) {
                Collapsible.init();
            }
        }

        syncDom();
        window.addEventListener('resize', syncDom);
    }

    function initShortInfoCollapsible() {
        const containers = document.querySelectorAll('.short__infoBlock > div');
        if (containers.length === 0) return;

        function syncDom() {
            const isMobile = window.innerWidth <= MOBILE_BP;

            containers.forEach(container => {
                const hasCollapsible = container.querySelector('.collapsible-header') !== null;

                if (isMobile && !hasCollapsible) {
                    const ulTag = container.querySelector('ul');
                    if (!ulTag) return;

                    const titleText = container.dataset.collapsibleTitle ?? '';

                    const { header, contentWrap } = buildCollapsibleShell(titleText);
                    container.replaceChildren(header, contentWrap);
                    contentWrap.appendChild(ulTag);
                } else if (!isMobile && hasCollapsible) {
                    const ulTag = container.querySelector('.collapsible-content ul');
                    if (ulTag) {
                        container.replaceChildren(ulTag);
                    }
                }
            });

            if (isMobile) {
                Collapsible.init();
            }
        }

        syncDom();
        window.addEventListener('resize', syncDom);
    }

    function initDesktopCpuIconSync() {
        document.querySelectorAll('.tab__block, .tab__block_short').forEach(block => {
            const iconEl = block.querySelector('.intel_icon, .amd_icon');
            const swiper = block.querySelector('.swiper');
            if (!iconEl || !swiper) return;

            function updateIcon() {
                let frontSlide = null;

                swiper.querySelectorAll('.slide').forEach(slide => {
                    const t = slide.style.transform || '';
                    if (t.includes('translate3d(0, 0, 0') || t === '') {
                        frontSlide = slide;
                    }
                });

                if (!frontSlide) {
                    frontSlide = swiper.querySelector('.slide.active') || swiper.querySelector('.slide');
                }
                if (!frontSlide) return;

                const header = frontSlide.querySelector('.card-header');
                const text = header ? header.textContent.toLowerCase() : '';
                const isAmd = text.includes('amd');

                iconEl.className = isAmd ? 'amd_icon' : 'intel_icon';
            }

            const observer = new MutationObserver(updateIcon);
            swiper.querySelectorAll('.slide').forEach(slide => {
                observer.observe(slide, { attributes: true, attributeFilter: ['style'] });
            });

            updateIcon();
        });
    }

    document.addEventListener('DOMContentLoaded', () => {
        initDynamicCollapsible('.cs__info > div', 'h2');
        initDynamicCollapsible('.dop_info > div', 'h3');
        initShortInfoCollapsible();
        initDesktopCpuIconSync();
    });
})();

/* ── 11. Redirect popup для ORDER_BASE_URL посилань ────────────── */
(function initCloudRedirectPopup() {
    const mirohostHost = (location.host || location.hostname)
        .replace('www.', '').replace('imena', 'mirohost').replace('ua', 'net');

    function showRedirectPopup(href) {
        const popup   = document.querySelector('.redirect_popup');
        const fade    = document.querySelector('.fade_');
        const titleEl = document.querySelector('.redirect_popup_title');
        const textEl  = document.querySelector('.redirect_popup_text');
        const reducer = document.querySelector('.redirect_popup_reducer');

        if (!popup || !fade) {
            location.href = href;
            return;
        }

        if (typeof window.is_popup_redirect !== 'undefined') {
            window.is_popup_redirect = true;
        }
        if (typeof window.popup_redirect_timeout !== 'undefined') {
            clearTimeout(window.popup_redirect_timeout);
        }

        if (titleEl) titleEl.innerHTML = I18N.redirectTitle;
        if (textEl)  textEl.innerHTML  = I18N.redirectText;

        popup.dataset.href = href;

        document.body.classList.add('popup_open');
        popup.classList.remove('hidden');
        fade.classList.remove('hidden');

        document.querySelector('.enter_block')?.classList.add('hidden');
        document.querySelector('.lang_list')?.classList.add('hidden');

        if (reducer) {
            const h = popup.querySelector('.redirect_popup_bg')?.offsetHeight ?? 0;
            reducer.style.top = ((window.innerHeight - h) / 2) + 'px';
        }

        popup.querySelector('.redirect_popup_loader')?.classList.add('start');

        window.popup_redirect_timeout = setTimeout(() => {
            if (window.is_popup_redirect) {
                window.is_popup_redirect = false;
                location.href = href;
                setTimeout(() => {
                    document.body.classList.remove('popup_open');
                    popup.classList.add('hidden');
                    fade.classList.add('hidden');
                }, 100);
            }
        }, 3000);
    }

    document.addEventListener('click', function (e) {
        const link = e.target.closest('a[href]');
        if (!link) return;
        if (!link.href.includes(mirohostHost)) return;
        if (link.classList.contains('other_site')) return;

        e.preventDefault();
        showRedirectPopup(link.href);
    });
})();

